import { UnmergedBranch } from 'types'

export enum FetchStatus {
  success = 'success',
  rejected = 'rejected',
  loading = 'loading',
}

export interface RemoveGuestModalProps {
  visible: boolean
  setVisible: (visible: boolean) => void
  onClose?: () => void
  onRemove: () => void
  onRemoveAndDelete: () => void
  onRemoveAndTransferOwnership: () => void
  guestName: string | null
  branches: UnmergedBranch[] | null
  status: FetchStatus
}

export interface RemoveGuestWithoutBranchesProps {
  onRemove: RemoveGuestModalProps['onRemove']
  guestName: RemoveGuestModalProps['guestName']
}

export interface RemoveGuestWithBranchesProps {
  onRemoveAndDelete: RemoveGuestModalProps['onRemoveAndDelete']
  onRemoveAndTransferOwnership: RemoveGuestModalProps['onRemoveAndTransferOwnership']
  branches: UnmergedBranch[]
  guestName: RemoveGuestModalProps['guestName']
}

export interface UnmergedBranchRowProps {
  branch: UnmergedBranch
}
